import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Tags, ShieldCheck } from 'lucide-react';

const ITEMS = [
  [ShieldCheck, 'Quality control', 'Every upload checked automatically for sync, gaps, blur and duplicates before it reaches you.', '/technology/quality'],
  [Tags, 'Labels & metadata', 'Every recording labelled from the task down to each hand action, with a full JSON record.', '/technology/labels'],
];

export const WhatYouGet = () => (
  <section className="py-24 lg:py-32 border-t border-white/10" data-testid="what-you-get-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#FF7A00]/70 mb-4 block">What you get</span>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-3xl mb-12">Checks and labels, built for robot learning</h2>
      <div className="grid gap-4 md:grid-cols-2">
        {ITEMS.map(([Icon, title, text, to], i) => (
          <motion.div key={to} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}>
            <Link to={to} data-testid={`wyg-${to.split('/').pop()}`}
              className="group flex flex-col h-full rounded-2xl border border-white/10 bg-[#141414] p-7 hover:border-[#FF7A00]/40 transition-colors">
              <Icon size={22} className="text-[#FF7A00] mb-5" />
              <h3 className="text-lg font-bold mb-2 group-hover:text-[#FF7A00] transition-colors">{title}</h3>
              <p className="text-sm text-white/50 leading-relaxed mb-6">{text}</p>
              <span className="mt-auto inline-flex items-center gap-1 text-xs font-semibold text-[#FF7A00]">Learn more <ArrowRight size={12} className="group-hover:translate-x-1 transition-transform" /></span>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export const RequestBand = () => (
  <section className="py-24 lg:py-28 border-t border-white/10" data-testid="request-band">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col lg:flex-row lg:items-end justify-between gap-8">
      <div>
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#FF7A00]/70 mb-4 block">Get in touch</span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-2xl">Let's build your dataset</h2>
        <p className="text-base text-white/45 max-w-xl mt-4">Tell us the tasks, environments and volume you need, and our team will scope a custom collection plan.</p>
      </div>
      <Link to="/contact" className="group inline-flex items-center gap-2 btn-gradient px-8 py-4 font-semibold text-sm rounded-full w-fit" data-testid="request-band-cta">
        Request Data <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
      </Link>
    </div>
  </section>
);
